import { TableRow, TableCell } from "../../../design/table";
import { EventTag } from "../../../models/EventTag";

interface SelectEventTagListItemProps {
  eventTag: EventTag;
  onClick: () => void;
}

const SelectEventTagListItem: React.FC<SelectEventTagListItemProps> = ({
  eventTag,
  onClick,
}) => {
  return (
    <TableRow key={eventTag._id} onClick={onClick}>
      <TableCell className={"font-bold"}>{eventTag.name}</TableCell>
    </TableRow>
  );
};

export default SelectEventTagListItem;
